import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Clock, Phone } from "lucide-react";
import { Card, PublicShell } from "@/components/PublicShell";
import { LinkHero } from "@/components/LinkHero";
import { itDate } from "@/components/kit";
import { api, errMsg } from "@/lib/api";

export default function Fornitori() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/fornitori/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);
  return (
    <PublicShell testId="supplier-page">
      {!err && <div className="mb-4"><LinkHero kind="fornitori" token={token} /></div>}
      {err && <Card><p data-testid="supplier-error">{err}</p></Card>}
      {!d && !err && <Card><p className="text-sm">Caricamento…</p></Card>}
      {d && (
        <div className="space-y-4">
          <Card>
            <div className="text-xs uppercase tracking-[0.3em] text-[#34B3B0]">Scheda fornitori</div>
            <h1 className="font-serif-it text-4xl text-[#0D2B3A]" data-testid="supplier-title">{d.evento_tipo} • {d.cliente_nome}</h1>
            <p className="text-sm text-[#47606B]">{itDate(d.evento_data)}{d.ora_inizio && ` • inizio ore ${d.ora_inizio}`} • {d.sede}{(d.ospiti.adulti || 0) + (d.ospiti.bambini || 0) > 0 && ` • ${(d.ospiti.adulti || 0) + (d.ospiti.bambini || 0)} ospiti`}</p>
          </Card>
          {d.referenti.length > 0 && <Card><h2 className="font-medium text-[#0D2B3A]">Referenti in struttura</h2>{d.referenti.map((r, i) => <a key={i} href={`tel:${r.tel}`} className="flex items-center gap-2 text-sm text-[#0B6E8F]" data-testid={`supplier-ref-${i}`}><Phone size={14} /> {r.ruolo}: {r.nome} {r.tel}</a>)}</Card>}
          {d.suppliers.length > 0 && (
            <Card>
              <h2 className="font-medium text-[#0D2B3A]">Fornitori e orari di arrivo</h2>
              {d.suppliers.map((s, i) => <div key={i} className="flex justify-between gap-3 text-sm border-t border-[#EAF5F7] pt-2" data-testid={`supplier-row-${i}`}><span><b>{s.categoria}</b> • {s.nome}{s.note && <span className="text-[#7B929C]"> • {s.note}</span>}</span><span className="whitespace-nowrap">{s.arrivo && `arrivo ${s.arrivo}`}</span></div>)}
            </Card>
          )}
          <Card>
            <h2 className="font-medium text-[#0D2B3A] flex items-center gap-2"><Clock size={16} /> Scaletta della giornata</h2>
            {!d.timeline.length && <p className="text-sm text-[#7B929C]">La scaletta sarà pubblicata a breve.</p>}
            {d.timeline.map((t, i) => <div key={i} className="flex gap-4 text-sm" data-testid={`supplier-tl-${i}`}><span className="font-serif-it text-lg text-[#0B6E8F] w-14 shrink-0">{t.ora}</span><span className="border-l-2 border-[#9FE3E0] pl-3">{t.attivita}{(t.chi || t.note) && <span className="block text-xs text-[#7B929C]">{[t.chi, t.note].filter(Boolean).join(" • ")}</span>}</span></div>)}
          </Card>
        </div>
      )}
    </PublicShell>
  );
}
